import { render, staticRenderFns } from "./ColumnContent.vue?vue&type=template&id=cfe073d2&"
import script from "./ColumnContent.vue?vue&type=script&lang=js&"
export * from "./ColumnContent.vue?vue&type=script&lang=js&"
import style0 from "./ColumnContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe073d2')) {
      api.createRecord('cfe073d2', component.options)
    } else {
      api.reload('cfe073d2', component.options)
    }
    module.hot.accept("./ColumnContent.vue?vue&type=template&id=cfe073d2&", function () {
      api.rerender('cfe073d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ColumnContent.vue"
export default component.exports